import { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { StoryResponseDto } from '../../../store/landscapeAPI/story/dto/response/story-response.dto';
import { LandscapeStoryOrganism } from '../../organisms';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import LandscapeStoryBaseEditTemplate from '../../../templates/LandscapeStoryBaseEditTemplate';

export interface LandscapeEditStoryTemplateProps {
  story: StoryResponseDto;
  handleOnChange: (story: StoryResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
  callbackFn: (story: StoryResponseDto) => void;
}

const LandscapeEditStoryTemplate: FC<LandscapeEditStoryTemplateProps> = ({
  story,
  handleOnChange,
  handleImageOnChange,
  callbackFn,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <LandscapeStoryBaseEditTemplate>
          <LandscapeStoryOrganism
            story={story}
            handleOnChange={handleOnChange}
            handleImageOnChange={handleImageOnChange}
            callbackFn={callbackFn}
          />
        </LandscapeStoryBaseEditTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeEditStoryTemplate;
